export default "__VITE_ASSET__90867201__"